import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['submit', 'status'];
  static values = { movedMessage: String };

  move(event) {
    const button = event.currentTarget;
    const row = button.closest('[data-route-banner-order-target="row"]');
    const sibling = button.dataset.direction === 'up' ? row.previousElementSibling : row.nextElementSibling;
    if (!sibling) return;

    if (button.dataset.direction === 'up') {
      row.parentNode.insertBefore(row, sibling);
    } else {
      row.parentNode.insertBefore(sibling, row);
    }

    this.refresh();
    this.submitTarget.disabled = false;
    const position = this.rows().indexOf(row) + 1;
    this.statusTarget.textContent = this.movedMessageValue.replace('%{position}', position);
    const fallbackButton = button.dataset.direction === 'up'
      ? row.querySelector('[data-route-banner-order-target="down"]')
      : row.querySelector('[data-route-banner-order-target="up"]');
    (button.disabled ? fallbackButton : button).focus();
  }

  refresh() {
    const rows = this.rows();
    rows.forEach((row, index) => {
      row.querySelector('[data-route-banner-order-target="position"]').textContent = index + 1;
      row.querySelector('[data-route-banner-order-target="up"]').disabled = index === 0;
      row.querySelector('[data-route-banner-order-target="down"]').disabled = index === rows.length - 1;
    });
  }

  rows() {
    return Array.from(this.element.querySelectorAll('[data-route-banner-order-target="row"]'));
  }
}
